import React, { FC } from 'react';
import { Heading } from '@edreamsodigeo/prisma-design-system';
import { AlternativeItineraryLayerTitleProps } from './types';
import { RawMoneyComponent } from '@components/Shared/Money';

export function calculatePriceDifference(
  selectedItinerary: { price?: { amount?: number } } | undefined,
  itinerary: { price?: { amount?: number } } | undefined
) {
  const selectedItineraryPrice = Math.ceil(
    selectedItinerary?.price?.amount || 0
  );
  const itineraryPrice = Math.ceil(itinerary?.price?.amount || 0);

  const priceDifference = Math.round(selectedItineraryPrice - itineraryPrice);

  return {
    selectedItineraryPrice,
    itineraryPrice,
    priceDifference,
  };
}

export const Highlight: FC<{ isPositive?: boolean }> = ({ children }) => {
  return (
    <Heading
      type="3"
      color="positive.50"
      weight="medium"
      sx={{ display: 'inline' }}
    >
      {children}
    </Heading>
  );
};

export const PriceDifference: FC<{
  itinerary: AlternativeItineraryLayerTitleProps['itinerary'];
  selectedItinerary: AlternativeItineraryLayerTitleProps['selectedItinerary'];
}> = ({ selectedItinerary, itinerary }) => {
  const { priceDifference } = calculatePriceDifference(
    itinerary,
    selectedItinerary
  );

  return (
    <RawMoneyComponent currency={selectedItinerary?.price?.currency || 'EUR'}>
      {Math.abs(priceDifference)}
    </RawMoneyComponent>
  );
};
